import React, { useEffect, useState } from 'react';
import Page from '../../components/Page';
import API from '../../api/externalLinks';
import Item from '../../components/Item';
import translations from '../../translations/de';
import translateLabel from '../../helpers/translateLabel';
import Input from '../../components/Input';

const ExternalLinks = () => {
    const [links, setLinks] = useState(null);
    const [edit, setEdit] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        API.getExternalLinks()
            .then((res) => setLinks(res.data))
            .catch((e) => console.log(e));
    }, []);

    return (
        links && (
            <Page>
                <Item
                    name={translations.external_links}
                    itemModel={{
                        frauen: links.frauen,
                        future: links.future,
                        fanshop: links.fanshop,
                        marktplatz: links.marktplatz,
                        mutz: links.mutz,
                    }}
                    edit={edit}
                    onEdit={() => setEdit(!edit)}
                    onSubmit={(event) => {
                        setLoading(true);
                        API.setExternalLinks(event)
                            .then((res) => {
                                setLinks(res.data || event);
                                setLoading(false);
                                setEdit(false);
                            })
                            .catch(() => setLoading(false));
                    }}
                    onCancel={() => setEdit(!edit)}
                    loading={loading}
                    determineInputType={({ name, register, error, disabled, index }) => (
                        <Input
                            key={index}
                            label={translateLabel(name)}
                            name={name}
                            type="text"
                            {...register(name, { required: true })}
                            error={error}
                            disabled={disabled}
                        />
                    )}
                ></Item>
            </Page>
        )
    );
};

export default ExternalLinks;
